import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Rating,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider, Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class SliderQuestionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rating: this.props.from,
            showDeleteButton: this.props.showDeleteButton

        };

    }

    componentDidMount() {

    }



    handleChange = (e) => this.setState({ rating: e.target.value })


    render() {
        const { rating } = this.state
        let question={
            text: this.props.text,
            from: this.props.from,
            to: this.props.to,
            questionId: this.props.questionId,
            typeName: this.props.typeName,
        }
        return (
            <div>



                <Header as='h4'><span style={{ color: 'red' }}>* &nbsp;</span> {question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={ {fontSize: '15px'} }>
                     <Icon name={'trash alternate'} link onClick={()=>{this.props.deleteQuestion(question.questionId)}} > </Icon>
                </span></Header>} </Header>


                                <div>Ocjena: {rating}</div>
                <br/>
                                <input
                                    type='range'
                                    min={question.from}
                                    max={question.to}
                                    value={rating}
                                    onChange={this.handleChange}
                                />




                    <ToastContainer hideProgressBar />

                {this.props.showDivider && <Divider/>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/SliderQuestionPreview.js